// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/admin": [7,[2]],
		"/admin/access-denied": [8,[2]],
		"/admin/eval-triage": [9,[2]],
		"/admin/invite": [10,[2]],
		"/admin/platform": [11,[2,3]],
		"/admin/platform/organisations/new": [16,[2,3]],
		"/admin/platform/organisations/[tenantId]": [12,[2,3,4]],
		"/admin/platform/organisations/[tenantId]/administrators": [13,[2,3,4]],
		"/admin/platform/organisations/[tenantId]/branding": [14,[2,3,4]],
		"/admin/platform/organisations/[tenantId]/learners": [15,[2,3,4]],
		"/admin/select-tenant": [17,[2]],
		"/admin/tenants/[tenantId]/administrators": [18,[2]],
		"/admin/tenants/[tenantId]/dashboard": [19,[2]],
		"/admin/tenants/[tenantId]/safeguarding": [20,[2]],
		"/arup": [21],
		"/c/[tenantSlug]": [22,[5]],
		"/c/[tenantSlug]/mock-interview": [23,[5]],
		"/c/[tenantSlug]/results/[resultSetId]": [24,[5]],
		"/dev/action-plan-tab-blink": [25],
		"/dev/result-card-uat": [26],
		"/embed/[tenantSlug]": [27],
		"/morgan-sindall": [28]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);